import { PHONE, NOLA_PHONE, locationSchema } from "../structured-data-core";

export function getMidwestStructuredData() {
  const url = "https://restorehair.com/locations/restore-midwest/";
  const description =
    "Restore your confidence with the top hair restoration team serving the Midwest. Over 20,000 procedures.";
  return [
    locationSchema("Chicago – Fulton Market", "159 N Sangamon St, Suite 200", "Chicago", "IL", PHONE, url, description),
    locationSchema("Chicago – Hancock Center", "875 North Michigan Avenue, 31st Floor", "Chicago", "IL", PHONE, url, description),
    locationSchema("Chicago Lincoln Park", "939 W. North Avenue, Suite 750", "Chicago", "IL", PHONE, url, description),
    locationSchema("Lake Forest", "100 S. Saunders Rd, Suite 150", "Lake Forest", "IL", PHONE, url, description),
    locationSchema("Oak Brook", "1415 22nd St, #950", "Oak Brook", "IL", PHONE, url, description),
    locationSchema("Schaumburg", "10 N. Martingale Rd, Suite 400", "Schaumburg", "IL", PHONE, url, description),
    locationSchema("Indianapolis", "450 E. 96th St, Suite 500", "Indianapolis", "IN", PHONE, url, description),
    locationSchema("Novi", "39555 Orchard Hill Place, Suite 600", "Novi", "MI", PHONE, url, description),
    locationSchema("Edina", "5201 Eden Ave, Suite 300", "Edina", "MN", PHONE, url, description),
    locationSchema("Kansas City", "2300 Main Street, Suite 900", "Kansas City", "MO", NOLA_PHONE, url, description),
    locationSchema("St. Louis", "2 Cityplace Dr, 2nd Floor", "St. Louis", "MO", PHONE, url, description),
    locationSchema("Cincinnati", "300 E. Business Way, Suite 200", "Cincinnati", "OH", PHONE, url, description),
    locationSchema("Columbus", "100 E. Campus View Boulevard, Suite 250", "Columbus", "OH", PHONE, url, description),
    locationSchema("Independence", "6100 Oak Tree Boulevard, Suite 200", "Independence", "OH", PHONE, url, description),
    locationSchema("Milwaukee", "250 East Wisconsin Avenue, Suite 1800", "Milwaukee", "WI", PHONE, url, description),
  ];
}
